import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import SalesForm from './form';
export default function UpdateSalesPerson(props) {
    const { id } = props.match.params;

    return (
        <div>
            <MyBreadcrumb items={[{ label: "Sales Person", path: "/sales" }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <SalesForm id={id} />
            </PageHeader>
        </div>
    );
}